export default __webpack_public_path__ + "static/fox-rash-0f99d3df10cb91abd52151b0a5eac9ec.png";